/**
 * Created by zhengyi.fu on 2020/12/11.
 */
let testPage = [
  {
    path: '/test',
    name: 'test',
    meta: {
      title: '测试'
    },
    component: function (resolve) {
      require(['@/views/Other/test'], resolve)
    }
  },
];
export default testPage;
